import {
  CUSTOM_ELEMENTS_SCHEMA, Inject,
  ModuleWithProviders,
  NgModule, Optional,
  importProvidersFrom
} from '@angular/core';

import { HeaderComponent } from './components/header/header.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { LeftMenuSearchBarComponent } from './components/left-menu/left-menu-search-bar/left-menu-search-bar.component';

import { PermissionsService } from './services/permissions.service';
import { CanonicalService } from './services/canonical/canonical.service';
import { AuthenticateService } from './services/authenticate.service';
import {ApprovalService} from './services/approval.service';

import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot/forgot-password.component';
import {ResetPasswordComponent} from './auth/reset/reset-password.component';
import { ConfirmDialogComponent } from './auth/reset/confirm-dialog/confirm-dialog.component';
import {OtpComponent} from './auth/otp/otp.component';

import { TokenStorage } from './services/token-storage.service';
import {AppGeneralConfig, GeneralConfigService} from './services/general-config.service';
import { APP_GENERAL_CONFIG, FooCommonModule, PARENT_ROUTES, ParentRoutes, ReplaceableComponentConfig, RouteService } from 'common-framework';

import { PipesModule } from './pipes/pipes.module';
import { SharedModule } from 'common-framework/shared-module';
import { SseService } from './services/sse.service';

const components: any = [
  LoginComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  OtpComponent,
  HeaderComponent,
  LeftMenuComponent,
  ConfirmDialogComponent,
  LeftMenuSearchBarComponent
];
const services: any = [
  CanonicalService,
  ApprovalService,
  AuthenticateService,
  PermissionsService,
  GeneralConfigService,
  TokenStorage,
  SseService,
  {
    provide: 'Permissions',
    useExisting: PermissionsService,
  }
];
@NgModule({
  declarations: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FooCommonModule,
    PipesModule,
    SharedModule
  ],
  exports: [
    ...components,
    FooCommonModule,
    PipesModule
  ],
})
export class FooFrameworkModule {
  static forRoot(
    config: AppGeneralConfig = {},
    componentsConfig?: ReplaceableComponentConfig[],
    parentRoutes?: ParentRoutes | ParentRoutes[]
  ): ModuleWithProviders<FooFrameworkModule> {
    return {
      ngModule: FooFrameworkModule,
      providers: [
        importProvidersFrom(FooCommonModule.forRoot(config, componentsConfig, parentRoutes)),
        ...services
      ]
    };
  }

  static forChild(
    parentRoutes?: ParentRoutes | ParentRoutes[]
  ): ModuleWithProviders<FooCommonModule> {
    return {
      ngModule: FooCommonModule,
      providers: [
        importProvidersFrom(FooCommonModule.forChild(parentRoutes)),
      ],
    };
  }



  constructor(
    generalConfig: GeneralConfigService, 
    @Optional() @Inject(APP_GENERAL_CONFIG) configs: AppGeneralConfig[]
  ) {
    if (!configs) {
      return;
    }
    configs.forEach((config: AppGeneralConfig) => {
      generalConfig.setConfig(config);
    });

  }
}
